import { delay } from '@lib/time/timers';
import { PaymentProviderType } from './types';

export const DELAY_TIMER = delay(5000);
export const REDIRECT_PAYMENT_PROVIDER_LIST = [
  PaymentProviderType.Paystack,
  PaymentProviderType.TLync,
];
